// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__mFgm5","cardHeader":"styles_cardHeader__2G6yA"};